<template>
  <v-container fluid grid-list-xs>
    <v-layout row wrap 
      v-if="!dialog">
      <v-flex xs12 md2 order-xs1 order-md1 >
        <h3>Dane kontaktowe</h3>
        <v-form class="mt-2"
          v-if="!hideDaneKontaktowe"
          v-model="valid">
          <v-text-field

            v-model="name"
            :rules="nameRules"
            label="Imię i Nazwisko"
            required
            box
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="E-mail"
            box
          ></v-text-field>
          <v-text-field
            v-model="phone"
            label="Telefon"
            mask="###########"
            box
          ></v-text-field>
          </v-form>
        </v-flex>
        <v-flex hidden-md-and-up  order-xs2>
          <v-btn round color="pink" dark @click="hideDaneKontaktowe = !hideDaneKontaktowe">{{ !hideDaneKontaktowe ? 'Ukryj' : 'Pokaż'}}</v-btn>
        </v-flex>
        <v-flex xs12 md6 offset-md1 order-xs4 order-md2>
          <v-card color="grey darken-1" class="white--text">
            <v-card-title primary-title>
              <div class="headline">Pytanie {{page}}/{{question.length}}</div><br>
            </v-card-title>
            <v-card-text>
              <div class="text-xs-left">{{question[page-1].question}} </div>
            </v-card-text>
            <v-card-actions >
            <v-radio-group
              class="text-md-right "
              row
              v-model="answer[page]"
            >
              <v-radio
                v-for="n in 6"
                :key="n"
                :label="` ${n}`"
                :value="n"
                dark
                color='pink'
                class="white--text"
              ></v-radio>
            </v-radio-group>
              </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md2 offset-md1 order-xs3 order-md3>
          <v-card color="grey darken-1" class="white--text">
            <v-card-title v-if="!hideInformacje" primary-title>
              <div class="headline">Informacje</div><br>
            </v-card-title>
            <v-card-text v-if="!hideInformacje">
              <div class="text-xs-left"><b>1</b> jeśli to twierdzenie zupełnie nie pasuje do ciebie, </div>
              <div class="text-xs-left"><b>2</b> lub <b>3</b> jeśli to twierdzenie pasuje do ciebie w niektórych sytuacjach</div>
              <div class="text-xs-left"><b>4</b> lub <b>5</b> jeśli to twierdzenie w dużej mierze pasuje do ciebie</div>
              <div class="text-xs-left"><b>6</b> jeśli to twierdzenie całkowicie do ciebie pasuje</div>
            </v-card-text>
            <v-card-actions>
        <v-flex hidden-md-and-up  >
          <v-btn round flat dark @click="hideInformacje = !hideInformacje">{{ !hideInformacje ? 'Ukryj' : 'Pokaż'}}</v-btn>
        </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 order-xs5 order-md4>
          <v-btn fab small color="pink" @click.native="prevPage()" :disabled="page === 1">
            <v-icon >arrow_back_ios</v-icon>
          </v-btn>
          <v-btn fab small color="pink" @click="nextPage()" :disabled="page === question.length || answer[page] === undefined">
            <v-icon dark>arrow_forward_ios</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 order-xs6 order-md5>
          <v-btn
          round
          :disabled="Object.keys(answer).length !== question.length || notSendSecond !== false"
          color="pink"
          class="white--text"
          @click.native="sendAnswers"
          >
            Wyślij odpowiedzi
            <v-icon right dark>send</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12
        v-if="messLocalStorage"
        >
          <h3>Juz jeden test zostal wyslany!</h3>
        </v-flex>

        <v-flex xs12 order-xs7 order-md6
          v-if="errorName !== '' && name === ''"
        >
          <v-alert
            :value="true"
            type="error"
            color="pink"
            dismissible
            @click="errorName = ''"
          >
            {{ errorName }}
          </v-alert>
        </v-flex>
<!-- <v-flex xs12>
  {{answer}}
  {{name}}
  {{email}}
  {{notSendSecond}}
</v-flex> -->
    <v-dialog
      v-model="sentConfirm"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="pink"
        dark
      >
        <v-card-text>
          {{ textMessage }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-dialog
      persistent
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
          Kwestionariusz "Moja kariera"
          </v-card-title>
          <v-card-text>
            Celem tego kwestionariusza jest zachęcenie Cię do refleksji na temat obszarów własnej kompetencji, motywacji do pracy i systemu wartości. Nie ma tu odpowiedzi dobrych i złych. Różne cechy opisane w Kwestionariuszu są równie dobre, a wypełnienie go ma posłużyć do opisania twoich kotwic kariery nie za do ich oceniania. Prosimy o przypisanie najwyższej rangi (najwyższej liczby punktów) tym zdaniom, które najlepiej Cię opisują, a niskiej rangi (najmniejszej liczby punktów) tym zdaniom, które do ciebie w ogóle nie pasują. Na przykład, jeśli twierdzenie mówi „Marzę o stanowisku prezesa firmy możesz przypisać mu następujące rangi d 1 do 6.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="getMe()"
            >
              Nie akceptuję
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="dialog = false"
            >
              Akceptuję
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'kwestionariuszmojakariera',
  data: () => ({
    notSendSecond: false,
    messLocalStorage: false,
    valid: '',
    question: '',
    answer: {},
    page: 1,
    dialog: true,
    nameRules: [
      v => !!v || 'Imię jest obowiązkowe',
      v => (v.length >= 3 && v.length <= 60) || 'Imie musi mieć conajmniej 3 znaki'
    ],
    name: '',
    email: '',
    iHaveName: false,
    errorName: '',
    sentConfirm: false,
    phone: '',
    errorMessage: '',
    textMessage: '',
    hideDaneKontaktowe: false,
    hideInformacje: false,
  }),
  watch: {
    sentConfirm (val) {
      if (!val) return

      setTimeout(() => (this.sentConfirm = false), 4000)
    }
  },
  created: function () {
    // if (localStorage.sendTest) {
    //     this.notSendSecond = localStorage.sendTest
    //     this.messLocalStorage = true
    // }
    const url = 'https://coachingspace.pl/php/test2.php'
    this.$http
      .get(url)
      .then(response => {
        this.question = response.data
      })
      .catch(error => {
        console.log('EEEE', error)
      })
  },
  methods: {
    nextPage () {
      return this.page++
    },
    prevPage () {
      return this.page--
    },
    getMe () {
      window.location = 'https://coachingspace.pl'
      return window.location
    },
    sendAnswers  () {
      if (this.name === '') {
        this.errorName = 'Musisz podać imię.'
      } else {
        const toSend = {}
        Object.assign(toSend, this.answer)
        toSend.name = this.name
        toSend.email = this.email
        toSend.phone = this.phone
        this.$http
          .post('https://coachingspace.pl/php/post2.php', JSON.stringify(toSend))
          .then(response => {
            // localStorage.sendTest = true
            // this.notSendSecond = true
            this.textMessage = 'Odpowiedzi zostały wysłane!'
            this.sentConfirm = true
          })
          .catch(error => {
            this.textMessage = 'Coś poszło nie tak. Odpowiedzi nie zostały wysłane!'
            this.sentConfirm = true
            console.log(error)
          })
      }
    }
  }
}
</script>

<style scoped>
.v-radio-button-end {
    align-items: flex-end;
}
</style>
